export const MIDDLEWARE = Symbol('middleware');
export const DATA_MIDDLEWARE = Symbol('data-middleware');
export const CORE = Symbol('core');
export const PERMISSIONS = Symbol('permissions');
export const PERMISSION_KEYS = Symbol('permission-keys');
